module.exports = __webpack_public_path__ + "img/certified-repairs.0fcfea6e.jpg";